import axios from 'axios';
import { createLocalCourse } from './utils/create-local-course.js';

async function createCourseRequest(course, user) {
  if (!user) {
    throw new Error("createCourse(): A user must be logged in, in order to create a course");
  }
  const response = await axios.post(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/v2/Courses`, {
    ...course,
    userID: user.id,
    userInstitutionID: user.institution?.id,
    content: "",
    courseElements: []
  });
  const createdCourse = createLocalCourse(user, {
    ...course,
    id: response.data.objectID
  });
  return createdCourse;
}

export { createCourseRequest };
//# sourceMappingURL=request.create.js.map
